import { CodeBadge } from '../../../components/CodeBadge/CodeBadge'
import { ConfigScope } from '../../../types'
import type { DetailFieldDef } from '../../../types'

export function buildConfigScopeDetailFields(
  scope: ConfigScope,
  tenantCode: string | null,
  inventorySystemProfileCode: string | null,
  venueId: string | null,
): DetailFieldDef[] {
  switch (scope) {
    case ConfigScope.IspConfig:
      return [{ label: 'ISP', value: <CodeBadge code={inventorySystemProfileCode} /> }]
    case ConfigScope.TenantConfig:
      return [{ label: 'Tenant', value: <CodeBadge code={tenantCode} /> }]
    case ConfigScope.TenantIspConfig:
      return [
        { label: 'Tenant', value: <CodeBadge code={tenantCode} /> },
        { label: 'ISP', value: <CodeBadge code={inventorySystemProfileCode} /> },
      ]
    case ConfigScope.TenantVenueConfig:
      return [
        { label: 'Tenant', value: <CodeBadge code={tenantCode} /> },
        { label: 'Venue', value: <CodeBadge code={venueId} /> },
      ]
  }
}
